import { get } from 'lodash/fp';

import * as fromReducer from './reducer';

const getDistrictsFromReducer = get('territories.districts');

export const getIsLoading = state => fromReducer.getIsLoading(getDistrictsFromReducer(state));

export const getDistricts = state => fromReducer.getDistricts(getDistrictsFromReducer(state));
